import { FC } from 'react';
import { Button, Tag } from './styles';
import { ButtonContainedProps } from './types';

export const ButtonContained: FC<ButtonContainedProps> = ({
	children,
	padding,
	onClick,
	isFullWidth = false,
	background = '',
	borderColor = '',
	color,
	hover = true,
	disabled = false,
	withTag = false,
  pen = false,
  id
}) => {
	return (
		<Button
			role="button-contained"
			$isFullWidth={isFullWidth}
			$padding={padding}
			$background={background}
			$color={color}
			$hover={hover}
			$disabled={disabled}
			$borderColor={borderColor}
      $pen={pen}
			onClick={!window.matchMedia("(pointer: coarse)").matches&&!disabled ? onClick : undefined}
			onTouchStart={onClick}
			disabled={disabled}
      id={id}
		>
			{children}
			{withTag && <Tag />}
		</Button>
	);
};
